import React from 'react';

const SuggestError = () => (
  <div className="mn-showload">
    <div className="w-70">
      <h1 className="text-center">
        The suggestion of this Movie has not been implemented yet on the server.
        Try another MOVIE ........
      </h1>
    </div>
  </div>
);

export default SuggestError;
